export const getPathArray = (path: string) => {
  return path.replace("/", "")?.split("/");
};

export const getPageName = (path: string) => {
  const pathArray = getPathArray(path);
  return pathArray[0] ? pathArray[0] : path;
};

export const getPageNameFromPath = () => {
  return getPageName(window.location.pathname);
};

export const getAcronyms = (fullName: string | undefined) => {
  if (!fullName) return "";

  const parts = fullName.split(" ").filter((name) => name.length > 0);

  if (parts.length === 0) return "";

  // Get first letter of first name
  const firstInitial = parts[0][0]?.toLocaleUpperCase() || "";

  // Get first letter of last name (if it exists)
  const lastInitial =
    parts.length > 1
      ? parts[parts.length - 1][0]?.toLocaleUpperCase() || ""
      : "";

  return [firstInitial, lastInitial].filter(Boolean);
};
